<template>
  <div class="container-app flex flex-col">
    <router-view name="navbar" @onBack="onBack" class="flex-none"/>
    <router-view class="flex-1"/>
    <Transition>
      <ErrorModal
        v-show="errorStatus"
        :connection="connection"
        :errorType="errorType"
        @closeError="resetError"
        @onBack="onBack"
      />
    </Transition>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ErrorModal from '@/components/modals/ErrorModal.vue';
import { onBeforeRouteUpdate } from 'vue-router';

export default {
  components: {
    ErrorModal,
  },
  data() {
    return {
      connection: true,
    };
  },
  computed: {
    ...mapState('global', ['errorStatus', 'errorMessage', 'errorType']),
  },
  methods: {
    ...mapActions('global', ['resetError', 'setError']),
  },
  mounted() {
    window.addEventListener('offline', () => {
      this.connection = false;
      this.setError({ status: true, err: { data: { detail: 'No Connection' } }, type: 0 });
    });
    window.addEventListener('online', () => {
      this.connection = true;
      this.setError({ status: false, err: { data: { detail: 'No Connection' } }, type: 0 });
    });
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const storage = localStorage.getItem(encodeURIComponent(token));
    if (storage) {
      this.$store.dispatch('global/setLoading', true, { root: true });
      const arr = JSON.parse(storage);
      this.$store.dispatch('global/setDob', arr[0], { root: true });
      this.$store.dispatch('global/setName', arr[1], { root: true });
      this.$store.dispatch('screening/getScreeningData', {
        token,
        dob: arr[0],
      });
    }
    onBeforeRouteUpdate(() => {
      this.$store.dispatch('global/setLoading', true, { root: true });
    });
  },
};
</script>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 0s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
